import React, { useEffect, useRef, useState } from "react";
import CatalogImage from "./CatalogImage";
import { getCachedIngredientImage, ingredientImageKey, loadIngredientImage } from "../../services/supabase/ingredientImages";

export default function IngredientImage({ ingredient, style, label }) {
  const ref = useRef(null);
  const [visibleKey, setVisibleKey] = useState(null);
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const key = ingredientImageKey(ingredient);
  const direct = ingredient.imagen || ingredient.imageUrl;
  const cached = ingredient.imageDeferred ? getCachedIngredientImage(ingredient) : undefined;
  const resolved = result?.key === key && result?.source === direct ? result : null;
  const url = resolved?.error ? null : direct || cached || resolved?.url;

  useEffect(() => {
    if (!ingredient.imageDeferred || direct) return undefined;
    if (typeof IntersectionObserver === "undefined") { setVisibleKey(key); return undefined; }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisibleKey(key); observer.disconnect(); }
    }, { rootMargin: "100px" });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ingredient.imageDeferred, direct, key]);

  useEffect(() => {
    if (visibleKey !== key || !ingredient.imageDeferred || direct || cached !== undefined) return undefined;
    let current = true;
    loadIngredientImage(ingredient).then(
      (image) => { if (current) setResult({ key, source: direct, url: image }); },
      () => { if (current) setResult({ key, source: direct, error: true }); }
    );
    return () => { current = false; };
    // The key contains all fields that identify an image, independent of recipe/stock edits.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, visibleKey, direct, ingredient.imageDeferred, cached, attempt]);

  return <div ref={ref} style={{ ...style, position: "relative", overflow: "hidden", backgroundColor: "#f3f4f6" }}>
    <CatalogImage key={`${key}:${attempt}`} src={url} alt={label || ingredient.nombre || ingredient.name || "Ingrediente"}
      onError={() => setResult({ key, source: direct, error: true })}
      style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
    {resolved?.error && !url ? <button type="button" title="Reintentar foto" aria-label="Reintentar foto"
      onClick={(event) => { event.stopPropagation(); setResult(null); setAttempt((value) => value + 1); }}
      style={{ position: "absolute", bottom: 0, left: 0, width: "100%", border: 0, cursor: "pointer", fontSize: 11 }}>Reintentar foto</button> : null}
  </div>;
}
